
      import Setp from './setp.vue'
      import type { App, Plugin } from 'vue'

      export const SetpPlugin: Plugin = {
        install(app: App) {
          app.component('Setp', Setp)
        },
      }
      export { Setp }
      